import React, { useRef } from "react";
import { Box, Typography, Divider } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { DetailsPopover } from "../detailsPopover";
import useStyles from "./NotificationsBar.styles";
import { NotificationPopoverState } from "./NotificationsBar";

interface NotificationDetailsPopoverProps {
    popoverState: NotificationPopoverState;
    handlePaperEnter: () => void;
    handlePaperLeave: () => void;
    getNotificationText: (item: any) => string;
    notificationsPanelRef: React.RefObject<HTMLElement>;
    onClose: () => void;
}

export const NotificationDetailsPopover: React.FC<NotificationDetailsPopoverProps> = ({
    popoverState,
    handlePaperEnter,
    handlePaperLeave,
    getNotificationText,
    notificationsPanelRef,
    onClose,
}) => {
    const classes = useStyles();
    const { anchorEl, notification, mode } = popoverState;
    const panelHeight = notificationsPanelRef.current?.offsetHeight ?? undefined;
    const content = mode === 'detail'
        ? notification?.notification?.detail
        : notification?.notification?.body || getNotificationText(notification);

    return (
        <DetailsPopover
            isPopoverOpen={Boolean(anchorEl)}
            anchorEl={notificationsPanelRef.current}
            title={notification?.notification?.title || "Notification"}
            items={
                <div
                    className={classes.popoverContent}
                    dangerouslySetInnerHTML={{ __html: content || '' }}
                />
            }
            actions={{
                paperEnter: handlePaperEnter,
                popoverLeave: mode === 'detail' ? () => { } : handlePaperLeave,
            }}
            onClose={mode === 'detail' ? onClose : undefined}
            maxWidth={400}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            sx={{
                maxHeight: panelHeight ?? 'none',
                overflowY: 'auto',
                boxSizing: 'border-box',
                ml: -1
            }}
        />
    );
};
